<template>
  <div class="flex-grow">
    <div class="flex">
      <div class="flex-grow">
        <div>
          {{ $t("product.product") }} <span class="font-bold">
            {{ productMap[lot.productUuid].code }} - {{ JSON.parse(productMap[lot.productUuid].multilangName)[$i18n.locale] }}
          </span>
        </div>
      </div>
    </div>
    <div class="flex mt-2">
      <div
        class="w-full grid grid-cols-2"
        :class="{ 'md:w-3/5 md:grid-cols-4': !inModal }"
      >
        <div>
          <div class="bg-white shadow">
            <div class="text-center text-xs bg-corepla-bg-dark text-white py-1">
              {{ $t("common.quantity") }}
            </div>
            <div class="font-semibold text-center py-2 bg-corepla-bg-light h-[40px] md:h-[50px]">
              {{ lot.quantity }} t
            </div>
          </div>
        </div>
        <div>
          <div class="bg-white shadow">
            <div class="text-center text-xs bg-corepla-bg-dark text-white py-1">
              {{ $t("auction.effective_price") }}
            </div>
            <div class="font-semibold text-center py-2 bg-corepla-bg-light h-[40px] md:h-[50px]">
              {{ lot.price }} €/t
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    lot: {
        type: Object,
        required: true
    },
    productMap: {
        type: Object,
        required: true
    },
    inModal: {
      type: Boolean,
      default: false
    }
})
</script>